/** @jsxImportSource @emotion/react */
'use client';

import React from 'react';
import { StyledSkeleton } from './styled';
import type { SkeletonProps } from './types';

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  (
    {
      width,
      height,
      aspectRatio,
      rounded = false,
      as,
      className,
      testId = 'skeleton',
      css,
      style,
      ...rest
    },
    ref
  ) => {
    return (
      <StyledSkeleton
        ref={ref}
        as={as}
        aria-hidden="true"
        data-testid={testId}
        $width={width}
        $height={height}
        $aspectRatio={aspectRatio}
        $rounded={rounded}
        className={className}
        css={css}
        style={style}
        {...rest}
      />
    );
  }
);

Skeleton.displayName = 'Skeleton';
